<section class="intro">
  <div class="left">
    <img src="../../../assets/Marka Logosu/KardelenLogo.svg" style=" width: 150px; height: 70px; ">

  <div class="card-container">
    <div class="glass">
      <div class="mb-10 card-header">
        <div class="logo-row">
          <img src="assets/HrefProLogo.svg" style="width: 150px; height: 70px;" alt="HrefPro Logo" class="logo">
        </div>
      </div>

      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="card-body text-end">
        <!-- Username Input -->
        <div class="form-group">
          <label class="form-label text-danger">{{ 'Lütfen Şifrenizi Değiştirin' }}</label>
          <div class="input-group">
          </div>
        </div>

        <div class="mb-2 row">
          <div class="col-lg-2 d-flex align-items-center justify-content-center">
            <i style="font-size: 18px;" class="bi bi-person-fill"></i>
          </div>
          <div class="col-lg-10">
            <div class="form-outline">
              <div class="input-group">
                <input class="form-control input-large"
                      [type]="hide ? 'password' : 'text'"
                      formControlName="password"
                      placeholder="Şifre"
                      (keydown)="onKeyDown($event)"
                      required>
              </div>
              <div *ngIf="passwordForm.get('password')?.errors?.['required'] && passwordForm.get('password')?.touched"
                   class="text-danger">
                Şifre gereklidir
              </div>
              <div *ngIf="passwordForm.get('password')?.errors?.['minlength']"
                   class="text-danger">
                Şifre en az 6 karakter olmalıdır
              </div>
            </div>
          </div>
        </div>

        <div class="mb-2 row">
          <div class="col-lg-2 d-flex align-items-center justify-content-center">
            <i style="font-size: 18px;" class="bi bi-person-fill"></i>
          </div>
          <div class="col-lg-10">
            <div class="form-outline">
              <div class="input-group">
                <input class="form-control input-large"
                      [type]="hideConfirm ? 'password' : 'text'"
                      formControlName="passwordConfirm"
                      placeholder="Şifre Tekrar"
                      (keydown)="onKeyDown($event)"
                      required>
              </div>
              <div *ngIf="passwordForm.get('passwordConfirm')?.errors?.['required'] && passwordForm.get('passwordConfirm')?.touched"
                   class="text-danger">
                Şifre gereklidir
              </div>
              <div *ngIf="passwordForm.get('passwordConfirm')?.errors?.['minlength']"
                   class="text-danger">
                Şifre en az 6 karakter olmalıdir
              </div>
            </div>
          </div>
        </div>

        <!-- Version -->
        <div class="mt-3 mb-2 d-flex justify-content-around">
          <label class="form-check-label">Sürüm {{ version }}</label>
        </div>

        <!-- Submit Button -->
        <div class="gap-2 d-grid">
          <button type="submit"
                  class="btn btn-primary button-large"
                  [disabled]="passwordForm.invalid">
            Şifreyi Değiştir
          </button>
        </div>
      </form>
    </div>
  </div>




</div>
<div>
  <div class="slider"  #sliderContainer>
    <ul>
      <li style="background-color: #253A55;">
        <div class="center-y">
          <img src="assets/login/bir.png" alt="Slider Image">
          <h1 style="color: hsl(218, 81%, 95%)">
            İnsana Değer Ver,
            <span style="color: hsl(218, 81%, 75%)">Geleceği Birlikte İnşa Et!</span>
          </h1>
          <p class="opacity-70" style="color: hsl(218, 81%, 85%)">
            Güçlü insan kaynakları, başarıyı inşa eder. Biz, değerli çalışanlarımızın potansiyelini
            keşfeder, geliştirir ve onlara destek sağlayarak birlikte büyük başarılar elde ederiz.
            Birlikte, sadece bugünü değil, yarını da şekillendiririz. İnsana değer veren bir
            vizyonla, geleceği birlikte inşa etmek için yola çıkıyoruz.
          </p>
          </div>
      </li>

      <li style="background-color: #253A55;">
        <div class="center-y">
          <img src="assets/login/iki.png" alt="Slider Image">
          <h1 style="color: hsl(218, 81%, 95%)">
            İK'nın Vizyonumuz,
            <span style="color: hsl(218, 81%, 75%)">Geleceği Birlikte İnşa Et!</span>
          </h1>
          <p class="opacity-70" style="color: hsl(218, 81%, 85%)">
            Her çalışan, benzersiz yeteneklerle donatılmış bir hazinedir.
            Biz, bu hazineleri keşfetmek, parlatmak ve onlara değer katmak için varız.
            İnsan kaynakları yaklaşımımız, çalışanlarımızın potansiyelini açığa çıkararak,
            onları geleceğin liderlerine dönüştürmeyi hedefler.
            Bireysel gelişim ve kurumsal başarı, bizim için ayrılmaz bir bütündür.
            Gelin, bu yolculukta birlikte ilerleyelim ve geleceği şekillendirelim.
          </p>
          </div>
      </li>
      <li style="background-color: #253A55;">
        <div class="center-y">
          <img src="assets/login/uc.png" alt="Slider Image">
          <h1 style="color: hsl(218, 81%, 95%)">
            İK'nın Üç Sacayağı,
            <span style="color: hsl(218, 81%, 75%)">Geleceği Birlikte İnşa Et!</span>
          </h1>
          <p class="opacity-70" style="color: hsl(218, 81%, 85%)">
            İnsan kaynakları departmanımız, empati, inovasyon ve mükemmellik
            prensipleri üzerine inşa edilmiştir.
            Çalışanlarımızın ihtiyaçlarını anlamak için empati kuruyor,
            inovasyoniş süreçlerimizi sürekli iyileştirmek için yenilikçi
            çözümler üretiyor ve her adımda mükemmelliği hedefliyoruz.
          </p>
          </div>
      </li>
    </ul>

    <ul>
      <nav>
        <a href="#"></a>
        <a href="#"></a>
        <a href="#"></a>
      </nav>
    </ul>
  </div>
</div>
</section>

